import React, { Component } from 'react';
import { connect } from 'dva';
import { Button, Form, Tabs, Spin, message } from 'antd';
import { Upload, Parse } from 'nbugs-pc-import-parse';
import Container from '../../../../../components/Container';
import { GetQueryString } from '../../../../../utils/utils';
import { url } from '../../services/service-utils';
import styles from './index.less';

const { TabPane } = Tabs;

@Form.create()
@connect(({ courseTable }) => ({
  ...courseTable,
}))
class ImportCourse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: '1',
      spinning: false,
      taskId: '',
    };
    this.id = GetQueryString('id');
  }

  componentDidMount() {}

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'create/reset',
    });
  }

  handleOk = () => {
    const { dispatch } = this.props;
    const { taskId } = this.state;
    if (!taskId) {
      message.warning('请导入总课表');
      return;
    }
    dispatch({
      type: 'courseTable/fetchSetAssemble',
      params: {
        assembleId: taskId,
        type: 1,
        id: this.id,
      },
    });
  };

  changeTab = activeKey => {
    this.setState({ activeKey });
  };

  nextStep = () => {
    const { activeKey } = this.state;
    this.setState({ activeKey: `${Number(activeKey) + 1}` });
  };

  preStep = () => {
    const { activeKey } = this.state;
    this.setState({ activeKey: `${Number(activeKey) - 1}` });
  };

  onTaskIdChange = taskId => {
    this.setState({ taskId });
  };

  onParseSuccess = () => {
    console.log('onParseSuccess');
  };

  renderTabTitle = (activeKey, title, index) => {
    return (
      <span>
        <i
          className={
            activeKey === index ? 'common-icon-style active-style' : 'common-icon-style icon-style'
          }
        >
          {index}
        </i>
        {title}
      </span>
    );
  };

  renderFooter = () => {
    const { activeKey } = this.state;

    let footerParams = {};
    if (activeKey === '1') {
      footerParams = {
        states: !0,
        demFooter: (
          <Button type="primary" onClick={this.nextStep}>
            下一步
          </Button>
        ),
      };
    } else if (activeKey === '2') {
      footerParams = {
        states: !0,
        demFooter: (
          <>
            <Button type="default" onClick={this.preStep}>
              上一步
            </Button>
            <Button type="primary" onClick={this.handleOk}>
              确定
            </Button>
          </>
        ),
      };
    }
    return footerParams;
  };

  render() {
    const { activeKey, spinning, taskId } = this.state;

    const uploadProps = {
      appId: '86',
      sceneSign: 'zongkebiao',
      businessId: '1',
      onTaskIdChange: this.onTaskIdChange,
      onParseSuccess: this.onParseSuccess,
    };

    const parseProps = {
      taskId,
      onTaskIdChange: this.onTaskIdChange,
      onParseSuccess: this.onParseSuccess,
    };

    return (
      <Container
        breStates={!0}
        version={2}
        defaultPadding
        footerParams={this.renderFooter()}
        isPathParams
      >
        <Spin spinning={spinning}>
          <div className={styles.root}>
            <Tabs defaultActiveKey="1" activeKey={activeKey} onChange={this.changeTab}>
              <TabPane tab={this.renderTabTitle(activeKey, '信息填写', '1')} key="1">
                <div className="tips">
                  <span>*</span>任课表：请先
                  <a
                    download
                    href={`//${url.url}/course/term/class/export-template?termId=${this.id}`}
                  >
                    <Button type="primary">下载总课表模版</Button>
                  </a>
                  并进行相应的填写，再将编辑完整的excel文档从下方“上传”。
                </div>
                <Upload {...uploadProps} />
              </TabPane>
              <TabPane tab={this.renderTabTitle(activeKey, '对象选择', '2')} key="2">
                <Parse {...parseProps} className="import-parse" />
              </TabPane>
            </Tabs>
          </div>
        </Spin>
      </Container>
    );
  }
}

export default ImportCourse;
